// Isolated, update-proof fix: move each product card's .buy-buttons-block
// inside its .card-gallery element so the hover-reveal CSS in custom.css
// (which targets .card-gallery > .buy-buttons-block) can match it.
//
// This used to be handled inside assets/product-card.js's ProductCard
// custom element (connectedCallback), but Shopify's theme "Update" feature
// silently reverted that file to stock and dropped the customization.
// Rather than re-editing assets/product-card.js (which would just be
// reverted again on the next Update), this logic lives in its own file
// with its own <script> tag in snippets/scripts.liquid, so future Updates
// have no stock file to merge it into and can never remove it.
(function () {
function moveBuyButtonsIntoGallery(scope) {
if (!scope) return;
var contents;
if (scope.classList && scope.classList.contains('product-card__content')) {
contents = [scope];
} else if (scope.querySelectorAll) {
contents = scope.querySelectorAll('.product-card__content');
} else {
return;
}
contents.forEach(function (content) {
var gallery = content.querySelector(':scope > .card-gallery');
var buyButtons = content.querySelector(':scope > .buy-buttons-block');
if (gallery && buyButtons && buyButtons.parentElement !== gallery) {
gallery.appendChild(buyButtons);
}
});
}
function init() {
moveBuyButtonsIntoGallery(document);
var observer = new MutationObserver(function (mutations) {
mutations.forEach(function (mutation) {
mutation.addedNodes.forEach(function (node) {
if (node.nodeType === 1) {
moveBuyButtonsIntoGallery(node);
}
});
});
});
observer.observe(document.body, { childList: true, subtree: true });
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();
